export default "__VITE_ASSET__CfS1Kf$v__"